import { AgreementType, Gender, Guardian, ISignupSource, StrengthRatioForMuscleGroups } from 'fitbeat.models';
import { BookingSourceType, ProgramType } from 'fitbeat.models';
import { Level } from '../exercise';
import { IUserWorkoutDisplayInfo } from '../gymschedule/gymstateviewmodel';
import { UserProfile } from '../user';
import { UserWorkoutSession } from './userworkoutsession';

export enum UserWorkoutStatus {
    NewUser = 'NewUser',
    NewMinorUser = 'NewMinorUser',
    TrialUser = 'TrialUser',
    TrialMinorUser = 'TrialMinorUser',
    Other = 'Other',
}

export interface IStartTimeGroupedSessions {
    classTime: string;
    members: UserWorkoutSessionWithDisplayInfo[];
  }
export class UserWorkoutSessionWithDisplayInfo extends UserWorkoutSession implements IUserWorkoutDisplayInfo {
  public static getUserWorkoutStatus(userProfile: UserWorkoutSessionWithDisplayInfo): UserWorkoutStatus {
    const isUserMinor = UserProfile.isMinor(userProfile.dateOfBirth);
    const isUserPtApprovedWithinHour = UserWorkoutSessionWithDisplayInfo.isUserPtApprovedWithinHour(userProfile);
    const isPlanTrial = userProfile.currentPlanStatus === undefined;
    if (!this.hasUserBeenPtApproved(userProfile) || isUserPtApprovedWithinHour) {
      return isUserMinor ? UserWorkoutStatus.NewMinorUser : UserWorkoutStatus.NewUser;
    } else if (isPlanTrial) {
      return isUserMinor ? UserWorkoutStatus.TrialMinorUser : UserWorkoutStatus.TrialUser;
    }

    return UserWorkoutStatus.Other;
  }

    public static isUserPtApprovedWithinHour = (userProfile: UserWorkoutSessionWithDisplayInfo): boolean => {
        const HOUR = 1000 * 60 * 60;
        const anHourAgo = Date.now() - HOUR;
        return userProfile.ptApprovedAt > anHourAgo;
    }

    public static hasUserBeenPtApproved = (userProfile: UserWorkoutSessionWithDisplayInfo): boolean => {
        return userProfile.ptApprovedAt ? true : false;
    }

  public static hasAcceptedTermsAndConditions = (userProfile: UserProfile): boolean => {
    const hasMedicalAgreement = userProfile.legalAgreements?.find((item: any) => {
      return item.agreement === AgreementType.Medical;
    });
    const hasAcceptedUpdatedTerms = userProfile.legalAgreements?.find(
      (item) => item.agreement.includes('all-terms-and-conditions'),
    );
    return !!(hasMedicalAgreement || hasAcceptedUpdatedTerms);
  };

    public receivingHeartRateMonitorData: any;
    public uid: string;
    public userWorkoutStatus: UserWorkoutStatus;
    public avatar: string;
    public name: string;
    public userProfile: UserProfile;
    public fullname: string;
    public nickname: string;
    public bookingSource: BookingSourceType;
    public isPastWorkout: boolean;
    public isNewUser: boolean;
    public acceptedTermsAndConditions: boolean;
    public startZone: number;
    public mobileNumber: string;
    public heartRateMonitorIdentifier: string;
    public ptApprovedAt: number;
    public currentPlanId: string|undefined;
    public currentPlanStatus: string|undefined;
    public dateOfBirth: string;
    public gender: Gender;
    public weight: number | undefined;
    public height: number | undefined;
    public guardianInfo?: Guardian;
    public signupSource: ISignupSource;
    public longTermGoal?: ProgramType;
    public skillLevel?: Level;
    public continueSignupLink?: string;
    public enrolledFaceId?: string;
    public leadStatus?: string;
    public email: string;
    public strengthRatioForMuscleGroups?: StrengthRatioForMuscleGroups;
}
